import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HiroApi, HiroApiImpl } from './apis';
import { HiroExampleService, HiroExampleServiceImpl } from './example/services/hiro-example-service';

export const hiroContainer = new ContainerModule((bind) => {
    bind(HiroApi).to(HiroApiImpl);

    bind(HiroExampleService).to(HiroExampleServiceImpl);
});
